import React from 'react'
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Box } from "@material-ui/core";

import github from '../images/github.png'
import linkedin from '../images/linkedin.png'
import medium from '../images/medium.png'
import facebook from '../images/facebook.png'
import hackerrank from '../images/hackerrank.png'

const useStyles = makeStyles(theme => ({
    mainContainer: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, 150%)",
        width: "50vw",
        height: "100px",
        paddingTop: "20px",
        textAlign: "center",
        zIndex: 1,
        borderRadius: 10,
        backgroundColor: "rgba(200, 200, 200, 0.25)",
        "@media (max-width: 900px)": {
            width: "90vw",
            height: "75px",
        }
    },
    root: {
        flexGrow: 1
    },
    media: {
        height: '60px',
        width: '60px',
        borderRadius: '50%',
        transition: 'transform .2s',
        "@media (max-width: 900px)": {
            height: '40px',
            width: '40px',
        },
        '&:hover': {
            transform: 'scale(1.5)',
         },
    },
    link: {
        textDecoration: 'none'
    }
}));

function SocialMedia() {
    const classes = useStyles();

    return (
        <div>
            <Box className={classes.mainContainer}>
                <Grid container className={classes.root} spacing={2}>
                    <Grid item xs={12}>
                        <Grid container justify="center" spacing={4}>
                            <Grid item>
                                <a href='https://github.com/Mohamed-Razan'>
                                    <img src={github} alt='github' className={classes.media} />
                                </a>
                            </Grid>
                            <Grid item>
                                <a href='https://www.linkedin.com/in/mohamed-razan-9b67bb171/'>
                                    <img src={linkedin} alt='linkedin' className={classes.media} />
                                </a>
                            </Grid>
                            <Grid item>
                                <a href='https://mhdrazan7.medium.com/'>
                                    <img src={medium} alt='medium' className={classes.media} />
                                </a>
                            </Grid>
                            <Grid item>
                                <a href='https://www.facebook.com/mhdrazan.razan'>
                                    <img src={facebook} alt='facebook' className={classes.media} />
                                </a>
                            </Grid>
                            <Grid item>
                                <a href='https://www.hackerrank.com/mhdrazan7'>
                                    <img src={hackerrank} alt='hackerrank' className={classes.media} />
                                </a>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </div>
    )
}

export default SocialMedia
